export default "__VITE_ASSET__9efbde1d__"